module.exports = __webpack_public_path__ + "img/footer.5cef4a52.png";